import type { Placement } from "@floating-ui/react";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { TooltipContent } from "./TooltipContent";
import { Tooltip } from "./TooltipRoot";
import { TooltipTrigger } from "./TooltipTrigger";

export const TooltipContainer = ({
  children,
  content,
  enable = false,
  color = "black",
  text,
  className,
  contentClassName,
  placement = "top",
}: {
  children: ReactNode;
  content?: ReactNode;
  enable?: boolean;
  color?: "black" | "white";
  text?: ReactNode;
  className?: string;
  contentClassName?: string;
  placement?: Placement;
}) => {
  const side = placement.split("-")[0];

  if (content !== undefined) {
    return (
      <Tooltip placement={placement}>
        <TooltipTrigger className={className}>{children}</TooltipTrigger>
        <TooltipContent
          className={
            "w-max max-w-80 rounded-md bg-zinc-900 px-3 py-2 text-xs font-medium text-white shadow-lg dark:bg-zinc-100 dark:text-zinc-900"
          }
        >
          {content}
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tooltip placement={placement}>
      <TooltipTrigger className={className}>{children}</TooltipTrigger>
      {enable && (
        <TooltipContent
          className={twMerge(
            "Tooltip flex justify-center rounded-lg px-2 py-1 text-sm",
            color === "white"
              ? "border border-zinc-300 bg-zinc-50 text-zinc-700"
              : "bg-zinc-800 text-white",
            contentClassName,
          )}
        >
          {text}
          <span
            className={twMerge(
              "absolute block h-2 w-2 rotate-45",
              side === "top" && "-bottom-1",
              side === "bottom" && "-top-1",
              side === "left" && "top-1/2 -right-1 -translate-y-1/2",
              side === "right" && "top-1/2 -left-1 -translate-y-1/2",
              color === "white"
                ? "border border-zinc-300 bg-zinc-50"
                : "bg-zinc-800",
            )}
          />
        </TooltipContent>
      )}
    </Tooltip>
  );
};
